import { UseFormWatch } from 'react-hook-form';
import { LinkButton } from '../atoms/Button';
import { TCloudFileListForm } from '../../types/cloudStorage/CloudFileList';
import { useStyles } from './useStyles';
import { Grid } from '@material-ui/core';

type Props = {
  watch: UseFormWatch<TCloudFileListForm>;
  linkName: string;
  path: string;
};

export const TransisionButton = ({ watch, linkName, path }: Props) => {
  const constructId = watch('construct_id')?.value;
  const constructName = watch('construct_id')?.label;

  const classes = useStyles();

  //  案件が選択されていない場合は表示しない
  if (!constructId || constructId === 0) return null;

  return (
    <>
      <Grid item sm={6}>
        <div className={classes.buttonsContainer}>
          <div className={`${classes.flexWrap} ${classes.justifyRight}`}>
            <div className={classes.inlineButton}>
              <LinkButton
                to={{
                  pathname: `${path}`,
                  state: {
                    state: { id: constructId, name: constructName }
                  }
                }}
              >
                {linkName}
              </LinkButton>
            </div>
            <div className={classes.inlineButton}>
              <LinkButton
                to={{
                  pathname: `/constructions/${constructId}/edit`,
                  state: {
                    state: constructId
                  }
                }}
              >
                工事詳細
              </LinkButton>
            </div>
          </div>
        </div>
      </Grid>
    </>
  );
};
